import { render, staticRenderFns } from "./DataLayout.vue?vue&type=template&id=160288ff&"
import script from "./DataLayout.vue?vue&type=script&lang=js&"
export * from "./DataLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports